import * as React from "react"

const Pause = () => (
    <svg
		xmlns="http://www.w3.org/2000/svg"
		width={512}
		height={512}
		viewBox="0 0 16 16"
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M5 2a1 1 0 0 1 1 1v10a1 1 0 0 1-2 0V3a1 1 0 0 1 1-1m6 0a1 1 0 0 1 1 1v10a1 1 0 0 1-2 0V3a1 1 0 0 1 1-1"
			clipRule="evenodd"
		/>
	</svg>
)

export default Pause;
